<template>
  <div class="container">
    <bar-chart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"/>
  </div>
</template>

<script>
import BarChart from './Chart.vue'

export default {
  name: 'BarChartContainer',
  components: { BarChart },
  data: () => ({
    loaded: false,
    chartdata: null,
    options: {
      responsive: true,
      maintainAspectRatio: true,
      legend: {
        display: false
    },
    },
  }),
  async mounted () {
    this.loaded = false
       await axios.get('/api/kriteria').then((res)=>{
        //    const keterangan = this.res
          let dataset = {
           keterangan: res.data.data.map(item => item.keterangan),
          pinjaman_count: res.data.data.map(item => item.pinjaman_count)
           }
       this.chartdata = {
        labels: dataset.keterangan,
        datasets: [
          {
            backgroundColor: [  '#00D8FF','#41B883','#FF9000','#FF6347','#FF4500'],
            data:  dataset.pinjaman_count
          }
        ]
      }
    
      this.loaded = true
    //   console.log(this.chartdata)
      }).catch((e)=>{
        console.log(e)
      }) 
   
  }
}
</script>